<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-container
    id="data-tables"
    class="fill-height align-start"
    fluid
    tag="section"
  >
    <ik-data-table
      :model="model"
      entity-name="DiscountArea"
      icon="mdi-cash-usd"
    />
  </v-container>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Discount from '@/model/dataLayer/api/Vip/Discount'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Discount
    })
  }
}
</script>
